import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        link: {
            type: String,
            required: true,
        },
    },
    setup() {
        const handleClick = (link) => {
            if (link) {
                window.open(link.includes('http') ? link : `//${link}`);
            }
        };
        return {
            handleClick,
        };
    },
});
